import { render, staticRenderFns } from "./DeliveryView.vue?vue&type=template&id=2aa78328&scoped=true&"
import script from "./DeliveryView.vue?vue&type=script&lang=js&"
export * from "./DeliveryView.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryView.vue?vue&type=style&index=0&id=2aa78328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa78328",
  null
  
)

export default component.exports